import * as guideLayoutConsts from '../guide/constants/layout';
import * as colorConsts from '../guide/constants/colors';

export const theme = {
  ...guideLayoutConsts,
  ...colorConsts,
};
